module.exports = __webpack_public_path__ + "img/qr_code_badge_black_en.5e9fad23.svg";